import React from "react";
import {
  RouterProvider as ReactRouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import { public_router } from "./public-router";
import { private_router } from "./private-router";
export const RouterProvider = () => {
  return (
    <ReactRouterProvider
      router={createBrowserRouter([...public_router, ...private_router])}
    />
  );
};
